import { TagPill } from '@brush/ui';

/**
 * The parts the table row and the phone card both draw. Shared rather than copied because these
 * are the two things an operator identifies a tournament *by* at a glance — a status that read
 * differently between the two arrangements, or a tag that was a pill in one and plain text in the
 * other, would be the same record wearing two faces.
 */

/** Live is the one status worth colouring: it is the event happening now. */
export function StatusChip({ status }: { status: string }) {
  return (
    <span
      className={
        status === 'live'
          ? 'rounded-md bg-felt-50 px-2 py-1 text-xs font-medium text-felt-900'
          : 'rounded-md bg-ink-800/5 px-2 py-1 text-xs font-medium text-ink-800/60'
      }
    >
      {status}
    </span>
  );
}

/**
 * Up to three tags, the filtered ones first, then a count of whatever did not fit.
 *
 * `onEdit` is optional and the phone card does not pass it: the card is itself the control that
 * opens the tournament, a nested button inside it would be invalid, and the detail view carries
 * the same edit one tap away.
 */
export function TournamentTags({
  tags,
  shown,
  platformTags,
  onEdit,
}: {
  /** Every tag the tournament carries — what the overflow count is computed from. */
  tags: string[];
  /** The same tags ordered for display, filtered ones first. */
  shown: string[];
  platformTags: string[];
  onEdit?: () => void;
}) {
  return (
    <div className="flex flex-wrap items-center gap-1.5">
      {shown.slice(0, 3).map((tag) => (
        <TagPill
          key={tag}
          label={tag}
          kind={platformTags.some((p) => p.toLowerCase() === tag.toLowerCase()) ? 'platform' : 'room'}
        />
      ))}
      {tags.length > 3 ? (
        <span className="text-[10px] text-ink-800/50">+{tags.length - 3}</span>
      ) : null}
      {onEdit ? (
        <button
          type="button"
          onClick={onEdit}
          className="ml-1 text-[10px] text-ink-800/50 underline underline-offset-2 hover:text-ink-950"
        >
          edit
        </button>
      ) : null}
    </div>
  );
}
